import { render } from "./profile-controller.view.vue?vue&type=template&id=600e2086&ts=true"
import script from "./profile-controller.view.vue?vue&type=script&lang=ts"
export * from "./profile-controller.view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__